import courseIcon from "assets/icons/icon-course.svg";
import { Box, Typography, Button as MuiButton } from "@mui/material";
import { Theme, styled } from "@mui/material/styles";
import withStyles from '@mui/styles/withStyles';
import { AttendanceFormErrorsEnum } from "../../Constants/AttendanceFormErrorsEnum";
import { PageNotFound } from "./PageNotFound";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AttendanceForm_attendanceFormData_Errors } from "AttendanceForm/Utils/GraphQl/AttendanceFormData";
import { typographyOverrides } from "AttendanceForm/Theme/Overrides/TypographyOverrides";

export interface AttendanceFormErrorProps {
  validationErrors?: AttendanceForm_attendanceFormData_Errors[];
}
const Figure = styled("figure")({
  display: "flex",
  flexDirection: "column",
  margin: "auto",
});
const ImageIcon = styled("img")({
  height: "89px",
  opacity: "0.5",
  marginBottom: "10px",
});
const Button = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 0,
    color: theme.palette.primary.main,
    width: "143px",
    height: "42px",
    margin: "0 auto",
  },
  label: {
    fontSize: 11,
    fontWeight: 700,
  },
  outlined: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  disabled: {
    color: theme.palette.grey["500"],
  },
}))(MuiButton);
export const AttendanceFormError: React.FC<AttendanceFormErrorProps> = ({
  validationErrors,
}): React.ReactElement => {
  const navigate = useNavigate();
  const { t: tcommon } = useTranslation("common");
  const getErrorMessages = (
    validationErrors: AttendanceForm_attendanceFormData_Errors[]
  ): React.ReactElement[] => {
    return validationErrors.map((validationError) => {
      if (validationError.errorCode == AttendanceFormErrorsEnum.EventNotAvailable) {
        return (
          <li style={{ textAlign: "left" }} key={validationError.errorCode}>
            {tcommon("eventNotAvailablePartOne")}
            <br />
            {tcommon("eventNotAvailablePartTwo")}
          </li>
        );
      }
      else if (validationError.errorCode == AttendanceFormErrorsEnum.InactiveLinkErrorCode) {
        return (
          <li style={{ textAlign: "left" }} key={validationError.errorCode}>
            {tcommon("linkIsNotActivePartOne")}
            <br />
            {tcommon("linkIsNotActivePartTwo")}
          </li>
        );
      }
      else if (validationError.errorCode == AttendanceFormErrorsEnum.LinkExpiredErrorCode) {
        return (
          <li style={{ textAlign: "left" }} key={validationError.errorCode}>
            {tcommon("linkExpiredPartOne")}
            <br />
            {tcommon("linkExpiredPartTwo")}
          </li>
        );
      }
      else {
        return (
          <li style={{ textAlign: "left" }} key={validationError.errorCode}>
            {validationError.errorMessage}
          </li>
        );
      }
    });
  };
  const eventNotAvailableErrorFound = validationErrors.find(
    (validationError: AttendanceForm_attendanceFormData_Errors) =>
      validationError.errorCode === AttendanceFormErrorsEnum.InvalidLinkErrorCode
  );
  return (
    <Box>
      {eventNotAvailableErrorFound ? (
        <PageNotFound />
      ) : (
        <>
          <Box padding={5}>
            <Figure>
              <ImageIcon src={courseIcon} alt="" />
            </Figure>
          </Box>
          <Box style={{ textAlign: "center" }}>
            <Typography variant="h1" color="primary" gutterBottom>
              {tcommon("attendanceFormError")}
            </Typography>
            <Typography align="left" style={typographyOverrides.h6} color="primary" gutterBottom>
              <ul style={{ display: "inline-block" }}>{getErrorMessages(validationErrors)}</ul>
            </Typography>
            <Typography align="left" style={typographyOverrides.h6} color="primary" gutterBottom>
              <ul style={{ display: "inline-block", listStyleType: "none" }}>
                <li style={{ textAlign: "left" }}>
                  {tcommon("linkValidationFailInstructionMessage")}
                </li>
              </ul>
            </Typography>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              {tcommon("goBack")}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};
